import * as api from '../api'
import * as types from './mutation-types'

export const getStatus = async ({ commit }, ctr) => {
  const res = await api.getAuthStatus(ctr)
  res && commit(types.REALNAME_VERIFY_STATUS, res)
}
